import React from 'react'
import { SwitchButton } from '../../../UI/SwitchButton/SwitchButton'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'
import { OptionsSwitchPutAwayUnknow } from '../../const/putAwayConst'

export const SwitchPutAwayUnknow = () => {
  const { state, dispatch } = usePutAway()
  const { setHeaderParamSearch } = putAwayActions()
  const { options } = OptionsSwitchPutAwayUnknow()

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    field: string
  ) => {
    e.preventDefault()
    dispatch(setHeaderParamSearch(field))
  }

  return (
    <SwitchButton
      options={options}
      isSelected={state.headerParamSearchValue}
      handleClick={handleClick}
    />
  )
}
